var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 387936113"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4650",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#D9D9D9",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M21.5 14.634C22.1667 15.0189 22.1667 15.9811 21.5 16.366L13.25 21.1292C12.5833 21.5141 11.75 21.0329 11.75 20.2631L11.75 10.7369C11.75 9.96706 12.5833 9.48593 13.25 9.87083L21.5 14.634Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPreview);
export default __webpack_public_path__ + "static/media/videoPreview.d879db012ce8cc47bfa317016e94e411.svg";
export { ForwardRef as ReactComponent };